var _path, _path2, _path3, _rect, _path4, _path5, _path6, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPropertyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 89,
    height: 73,
    fill: "none",
    viewBox: "0 0 89 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#131324",
    d: "M80.239 58.82a7.426 7.426 0 1 0 0-14.852 7.426 7.426 0 0 0 0 14.852z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#131324",
    d: "M25.996 2.438c0-1.07.867-1.937 1.937-1.937h32.932c1.07 0 1.938.867 1.938 1.937v69.974H25.996V2.438zM18.892 10.187c0-1.07.868-1.937 1.938-1.937h5.166v64.162h-7.104V10.187z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#131324",
    d: "M69.906 10.187c0-1.07-.868-1.937-1.938-1.937h-5.166v64.162h7.104V10.187z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 82.654,
    height: 1.002,
    x: 2.103,
    y: 71.998,
    fill: "#131324",
    rx: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#131324",
    d: "M79.844 58.391h1.002v13.626h-1.002z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#131324",
    d: "M7.927 58.82a7.426 7.426 0 1 0 0-14.852 7.426 7.426 0 0 0 0 14.852z",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#131324",
    d: "M7.532 58.391h1.002v13.626H7.532z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 4.52,
    height: 8.395,
    x: 32.453,
    y: 8.895,
    stroke: "#131324",
    rx: 2.257
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 4.52,
    height: 8.395,
    x: 32.453,
    y: 22.456,
    stroke: "#131324",
    rx: 2.257
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 4.52,
    height: 8.395,
    x: 42.139,
    y: 8.895,
    stroke: "#131324",
    rx: 2.257
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 4.52,
    height: 8.395,
    x: 42.139,
    y: 22.456,
    stroke: "#131324",
    rx: 2.257
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 4.52,
    height: 8.395,
    x: 51.179,
    y: 8.895,
    stroke: "#131324",
    rx: 2.257
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 4.52,
    height: 8.395,
    x: 51.179,
    y: 22.456,
    stroke: "#131324",
    rx: 2.257
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 4.52,
    height: 8.395,
    x: 32.453,
    y: 36.017,
    stroke: "#131324",
    rx: 2.257
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 4.52,
    height: 8.395,
    x: 42.139,
    y: 36.017,
    stroke: "#131324",
    rx: 2.257
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 4.52,
    height: 8.395,
    x: 51.179,
    y: 36.017,
    stroke: "#131324",
    rx: 2.257
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 4.52,
    height: 8.395,
    x: 32.453,
    y: 49.577,
    stroke: "#131324",
    rx: 2.257
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 4.52,
    height: 8.395,
    x: 42.139,
    y: 49.577,
    stroke: "#131324",
    rx: 2.257
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 4.52,
    height: 8.395,
    x: 51.179,
    y: 49.577,
    stroke: "#131324",
    rx: 2.257
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPropertyIcon);
export default __webpack_public_path__ + "static/media/property-icon.304dc202373fd5e5a0d0cfca441cf1c5.svg";
export { ForwardRef as ReactComponent };